"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.FilterSplitButton = void 0;
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var button_1 = require("@kaizen/button");
var component_library_1 = require("@kaizen/component-library");
var chevron_down_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/chevron-down.icon.svg"));
var clear_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/clear.icon.svg"));
var FilterSplitButton_module_scss_1 = __importDefault(require("./FilterSplitButton.module.scss"));
var FilterSplitButton = function (_a) {
    var labelText = _a.labelText, metadata = _a.metadata, onClick = _a.onClick, onFilterClear = _a.onFilterClear, onMouseDown = _a.onMouseDown, ariaControls = _a.ariaControls, ariaExpanded = _a.ariaExpanded, isDropdownVisible = _a.isDropdownVisible;
    if (metadata) {
        return (React.createElement("div", { className: FilterSplitButton_module_scss_1["default"].filterSelectButton },
            React.createElement("button", { onClick: onClick, type: "button", className: (0, classnames_1["default"])(FilterSplitButton_module_scss_1["default"].primaryActionButton, !onFilterClear && FilterSplitButton_module_scss_1["default"].noClearButton, isDropdownVisible && FilterSplitButton_module_scss_1["default"].splitButtonFocus) },
                React.createElement("span", { className: FilterSplitButton_module_scss_1["default"].filterName }, labelText),
                React.createElement("span", { className: FilterSplitButton_module_scss_1["default"].metadata }, metadata)),
            onFilterClear ? (React.createElement("button", { onClick: onFilterClear, type: "button", className: (0, classnames_1["default"])(FilterSplitButton_module_scss_1["default"].clearButton, isDropdownVisible && FilterSplitButton_module_scss_1["default"].splitButtonFocus) },
                React.createElement(component_library_1.Icon, { icon: clear_icon_svg_1["default"], role: "img" }))) : null));
    }
    return (React.createElement("div", { className: (0, classnames_1["default"])(FilterSplitButton_module_scss_1["default"].button, isDropdownVisible && FilterSplitButton_module_scss_1["default"].buttonActive) },
        React.createElement(button_1.Button, { secondary: true, label: labelText, icon: chevron_down_icon_svg_1["default"], iconPosition: "end", onClick: onClick, onMouseDown: onMouseDown, "aria-controls": ariaControls, "aria-expanded": ariaExpanded })));
};
exports.FilterSplitButton = FilterSplitButton;
//# sourceMappingURL=FilterSplitButton.js.map